import { fork } from 'redux-saga/effects';

import recommendationsSaga from './recommendations.js';
import recommendationsSettingsSaga from './recommendationsSettings.js';
import recommendationsGoalsSaga from './recoSettingsPriorityChange.js';

export default function* saga() {
  yield fork(recommendationsSaga);
  yield fork(recommendationsSettingsSaga);
  yield fork(recommendationsGoalsSaga);
}
